export const FILTER_VALUE_EMPTY = "empty"
